(() => {
  const mobileMenuDrawers = document.querySelectorAll('.mobile-menu-drawer');
  if (!mobileMenuDrawers.length) return;

  mobileMenuDrawers.forEach((mobileMenuDrawer) => {
    const mobileMenuItems = mobileMenuDrawer.querySelectorAll('[data-has-tier-2="true"]');

    mobileMenuItems.forEach((menuItem) => {
      const menuTitle = menuItem.getAttribute('data-mobile-menu-title');
      const tier2Container = mobileMenuDrawer.querySelector(`[data-mobile-tier-2="${menuTitle}"]`);

      if (!tier2Container) return;

      const backButton = tier2Container.querySelector('.menu-drawer-title.tier-2-title');

      menuItem.addEventListener('click', () => {
        tier2Container.classList.add('active');
        mobileMenuDrawer.style.overflow = 'hidden';
        // Scroll to top of drawer to display full height of tier 2 menu on small devices.
        mobileMenuDrawer.scrollTop = 0;
      });

      if (backButton) {
        backButton.addEventListener('click', () => {
          tier2Container.classList.remove('active');
          mobileMenuDrawer.style.overflow = 'auto';
        });
      }
    });
  });
})();
